/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarkupOverrideBulkRequest } from '../../models/markup-override-bulk-request';
import { MarkupOverrideBulkResult } from '../../models/markup-override-bulk-result';

export interface BulkUpdateCatalogEntryOverrides$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: MarkupOverrideBulkRequest
}

export function bulkUpdateCatalogEntryOverrides(http: HttpClient, rootUrl: string, params: BulkUpdateCatalogEntryOverrides$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkupOverrideBulkResult>> {
  const rb = new RequestBuilder(rootUrl, bulkUpdateCatalogEntryOverrides.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarkupOverrideBulkResult>;
    })
  );
}

bulkUpdateCatalogEntryOverrides.PATH = '/stores/{storeId}/catalog-entry-overrides/bulk-updates';
